import { useEffect } from 'react';
import { COUNTRY_NAME_BY_CURRENCY_MAP } from 'src/constants/country-name-by-currency-map';
import { MERCHANT_LIST_FOR_FINGERPRONT } from 'src/constants/merchant-list-for-fingerprint';
import { useAppContext } from 'src/context/store/app-provider';
import { useAnalytics } from 'src/hooks/use-analytics';
import { SegmentEventType, type SnippetType } from 'src/types/segment';
import { getVisitorId } from 'src/utils/get-visitor-id';

export const useLogSnippetCartRenderedEvent = ({
  planSelected,
  snippetType,
}: {
  planSelected?: number;
  snippetType: SnippetType;
}) => {
  const logAnalyticEvent = useAnalytics();
  const { currency, getExperiment, loading, publicKey, merchant } =
    useAppContext();
  const experiment2281 = getExperiment('CT-2281-widgets') || 'control';

  const isExperiment2281 =
    experiment2281 !== 'control' &&
    !!merchant &&
    MERCHANT_LIST_FOR_FINGERPRONT.includes(merchant);

  useEffect(() => {
    const send = (fingerprint?: Awaited<ReturnType<typeof getVisitorId>>) => {
      logAnalyticEvent({
        event: SegmentEventType.SNIPPET_CART_RENDERED,
        publicKey: publicKey ? 'yes' : 'no',
        merchantCountry: COUNTRY_NAME_BY_CURRENCY_MAP[currency],
        fingerprint,
        planSelected,
        snippetType,
      });
    };

    if (loading) return;
    if (window.tabbyFingerprintSent) return;

    window.tabbyFingerprintSent = true;

    if (isExperiment2281) {
      getVisitorId(experiment2281)
        .then((fingerprint) => {
          send(fingerprint);
        })
        .catch(() => {
          send();
        });
    } else {
      send();
    }
  }, [
    logAnalyticEvent,
    publicKey,
    planSelected,
    snippetType,
    currency,
    loading,
    experiment2281,
    isExperiment2281,
  ]);
};
